import type { Http } from '../http';
import { endpoints } from '../endpoints';
import type { RequestOptions } from '../types/common';
import type {
  RawPlantAccountsParams,
  RawPlantAccountsResponse,
  RawPlantDetailParams,
  RawPlantListResponse,
  RawPlantResponse,
  RawPlantSearchParams,
  RawPlantUpdateRequest,
} from '../types/plant';

export function createPlantApi(http: Http) {
  return {
    /** GET /api/v2/plants — 발전소 목록 조회 */
    async list(
      params?: RawPlantSearchParams,
      options?: RequestOptions,
    ): Promise<RawPlantListResponse> {
      const res = await http.get<RawPlantListResponse>(endpoints.plant.list, {
        params,
        signal: options?.signal,
      });
      return res.data;
    },

    /** GET /api/v2/plants/{plantId} — 발전소 단건 조회. `include=subscription,order` 로 구독·최신주문 동반 조회. */
    async detail(
      plantId: number,
      params?: RawPlantDetailParams,
      options?: RequestOptions,
    ): Promise<RawPlantResponse> {
      const res = await http.get<RawPlantResponse>(endpoints.plant.byId(plantId), {
        params,
        signal: options?.signal,
      });
      return res.data;
    },

    /**
     * PATCH /api/v2/plant/{plantId} — 발전소 정보 수정(백오피스, 수정 가능 필드만). [BE 미구현/미검증]
     * 응답 shape 미확정 → `RawPlantResponse`(수정 후 발전소)로 가정. 소비측은 상세 재조회로 갱신(응답 미의존).
     */
    async update(
      plantId: number,
      data: RawPlantUpdateRequest,
      options?: RequestOptions,
    ): Promise<RawPlantResponse> {
      const res = await http.patch<RawPlantResponse>(endpoints.plant.update(plantId), data, {
        signal: options?.signal,
      });
      return res.data;
    },

    /** GET /api/v2/plants/{plantId}/accounts — 발전소 연동 계정 목록(활성, accountId 오름차순, 서버 페이지네이션). */
    async accounts(
      plantId: number,
      params?: RawPlantAccountsParams,
      options?: RequestOptions,
    ): Promise<RawPlantAccountsResponse> {
      const res = await http.get<RawPlantAccountsResponse>(endpoints.plant.accounts(plantId), {
        params,
        signal: options?.signal,
      });
      return res.data;
    },
  };
}
